import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const { loginWithMultiplai } = useAuth();
  const navigate = useNavigate();
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    const code = searchParams.get("code");
    const error = searchParams.get("error");

    if (error) {
      const errorDesc = searchParams.get("error_description") || searchParams.get("message") || error;
      toast.error(`Multiplai login failed: ${errorDesc}`);
      navigate("/signin", { replace: true });
      return;
    }

    if (!code) {
      toast.error("No authorization code received.");
      navigate("/signin", { replace: true });
      return;
    }

    loginWithMultiplai(code)
      .then(() => {
        toast.success("Welcome!");
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        toast.error(err.response?.data?.detail || "Multiplai login failed.");
        navigate("/signin", { replace: true });
      });
  }, [searchParams, loginWithMultiplai, navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-[#F3F3F9]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-3 border-[#4D11F6] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-[#676970]">Signing you in with Multiplai…</p>
      </div>
    </div>
  );
}
